import { menuLandingPage } from './menuLandingPage';
import { ThemeUICSSObject } from '@apia/theme';
const menuLandingPageIndex: ThemeUICSSObject = {
  menuLandingPage,
};

export { menuLandingPageIndex };
